import * as React from "react";

export const ResourceFetchError: React.FC<{
  faIcon?: string;
  title: string;
  subtitle: string | React.ReactNode;
}> = ({ faIcon = "fa-exclamation-triangle", title, subtitle }) => {
  return (
    <div
      style={{
        border: "1px solid lightgrey",
      }}
    >
      <div className="columns is-centered is-vcentered has-text-centered pt-6 pb-6">
        <div className="column pt-6 pb-4">
          <p
            className="title has-text-weight-normal mt-4"
            style={{
              marginBottom: "48px",
            }}
          >
            <span
              className="icon"
              style={{
                fontSize: "80px",
              }}
            >
              <i className={`fas ${faIcon}`} />
            </span>
          </p>
          <p className="title has-text-weight-normal">{title}</p>
          <p className="subtitle">{subtitle}</p>
        </div>
      </div>
    </div>
  );
};
